/** @jsx jsx */

/** @jsxFrag */
import { jsx } from '@emotion/react';

import { useContext } from 'react';

import { Grid } from '@coursera/cds-core';

import { ProfileContext } from 'bundles/account-profile/components/recruiting-profile-viewer/ProfileContextProvider';
import { credentialType } from 'bundles/account-profile/components/recruiting-profile-viewer/utils/credentialUtils';

import HighlightsSectionCredentialsItem from './HighlightsSectionCredentialsItem';

const MAX_ITEMS_TO_SHOW = 3;

const HighlightsSectionCredentials = () => {
  const { profileState } = useContext(ProfileContext);

  const { completedProfessionalCertificates, completedSpecializations } = profileState?.courseraHistory ?? {
    completedProfessionalCertificates: [],
    completedSpecializations: [],
  };

  // Confirmed with BE, courseraHistory is sorted by BE from the most recent to oldest
  const certificateLength = completedProfessionalCertificates.length;
  const specializationLength = completedSpecializations.length;
  const amountOfSpecializationToShow = MAX_ITEMS_TO_SHOW - certificateLength;

  if (certificateLength + specializationLength === 0) return null;

  const certificatesToRender = completedProfessionalCertificates.slice(0, MAX_ITEMS_TO_SHOW);
  const specializationsToRender =
    amountOfSpecializationToShow > 0 ? completedSpecializations.slice(0, amountOfSpecializationToShow) : [];

  return (
    <Grid container spacing={16} direction="column">
      {/*
       * Prioritize Professional Certificates over specializations here.
       * If they have 2 prof certs, show the most recent prof cert on top, and then the most recent specialization third.
       * If they have 3+ prof certs, order top 3 by date as well
       */}
      {certificatesToRender.map((credential) => (
        <HighlightsSectionCredentialsItem
          key={credential.verifyCode}
          credential={credential}
          credentialType={credentialType.CERTIFICATE}
        />
      ))}

      {specializationsToRender.length > 0
        ? specializationsToRender.map((credential) => (
            <HighlightsSectionCredentialsItem
              key={credential.verifyCode}
              credential={credential}
              credentialType={credentialType.SPECIALIZATION}
            />
          ))
        : null}
    </Grid>
  );
};

export default HighlightsSectionCredentials;
